import React from 'react';
import './../index.css';
import { LevelLinks } from './LevelLinks';
import { LevelNav } from './LevelNav';
import { LevelText } from './LevelText';
import { LevelTitle } from './LevelTitle';
import { LevelChildren } from './LevelChildren';
import { LevelBooks } from './LevelBooks';
import { LevelVideos } from './LevelVideos';
import { LevelMovies } from './LevelMovies';
import { LevelFooter } from './LevelFooter';

export class LevelNode extends React.Component {

  render() {
    const map = this.props.map;
    const level = this.props.level;
    const displayLevel = map.get(level);
    if (0 === map.size) {
      return (
        <div>
          {'Loading...'}
        </div>
      );
    } else if (!displayLevel) {
      let defaultTitle = map.get('1').title;
      return (
        <>
          <LevelTitle
            title={defaultTitle}
          />
          <LevelNav
            parentTitle={defaultTitle}
            parentIndex={'1'}
            onLevelClick={(i) => this.props.onLevelClick(i)}
            searchValue={'-1'}
            searchChange={''}
          />
          <p>
            Content not found for passed index!
          </p>
        </>
      );
    } else {
      return (
        <>
          <LevelTitle
            title={displayLevel.title}
          />
          <LevelNav
            parentTitle={null !== displayLevel.parent ? displayLevel.parent.title : 'unknown parent'}
            parentIndex={null !== displayLevel.parent ? displayLevel.parent.index : '0.'}
            onLevelClick={(i) => this.props.onLevelClick(i)}
            searchChange={(i) => this.props.searchChange(i)}
            searchValue={this.props.searchValue}
          />
          {displayLevel.videos &&
            <LevelVideos
              videos={displayLevel.videos}
            />
          }          
          {displayLevel.text &&
            <LevelText
              text={displayLevel.text}
            />
          }
          {displayLevel.books &&
            <LevelBooks
              books={displayLevel.books}
            />
          }                
          {displayLevel.movies &&
            <LevelMovies
              movies={displayLevel.movies}
            />
          }          
          {displayLevel.links &&
            <LevelLinks
              links={displayLevel.links}
            />
          }
          {displayLevel.children &&
            <LevelChildren
              children={displayLevel.children}
              onLevelClick={(i) => this.props.onLevelClick(i)}
            />
          }
          <LevelFooter/>

        </>
      );
    }
  }
}
